export default __webpack_public_path__ + "static/media/2329.ce7125f3.png";